import { useEffect } from 'react';

/**
 * Blocks navigation triggered by links on the current page.
 */
export function useLockPageNavigation(locked = true) {
  useEffect(() => {
    if (!locked) return;

    const onClick = (event: MouseEvent) => {
      if (event.defaultPrevented) return;

      const target = event.target;
      if (!(target instanceof Element)) return;
      if (target.closest('[data-allow-leave]')) return;

      const anchor = target.closest('a[href]');
      if (!(anchor instanceof HTMLAnchorElement)) return;
      if (anchor.target === '_blank') return;

      event.preventDefault();
      event.stopPropagation();
    };

    document.addEventListener('click', onClick, true);
    return () => document.removeEventListener('click', onClick, true);
  }, [locked]);
}
